import { getBaseUrlInClient, getBaseUrlInServer } from './baseUrlHelper';

export const getDynamicEnvVarsInServer = async () => {
  const baseUrl = await getBaseUrlInServer();

  return {
    NEXT_PUBLIC_CW_AUTH_URL: `${baseUrl}/auth/v1`,
    NEXT_PUBLIC_API_URL: `${baseUrl}/auth/v1`,
    NEXT_PUBLIC_NEST_API_URL: `${baseUrl}/usm/v1`,
    NEXT_PUBLIC_USM_UI_HOST_URL: `${baseUrl}/`,
    NEXT_PUBLIC_USM_BACKEND_API_URL: `${baseUrl}/usm/v1`,

    // NEXT_PUBLIC_CW_AUTH_URL: 'http://localhost:5000/auth/v1',
    // NEXT_PUBLIC_API_URL: 'http://localhost:5000/auth/v1',
    // NEXT_PUBLIC_NEST_API_URL: 'http://localhost:5050/usm/v1',
    // NEXT_PUBLIC_USM_UI_HOST_URL: 'http://localhost:3000',
    // NEXT_PUBLIC_USM_BACKEND_API_URL: 'http://localhost:5050/usm/v1',
  };
};

export const getDynamicEnvVarsInClient = () => {
  const baseUrl = getBaseUrlInClient();

  return {
    NEXT_PUBLIC_CW_AUTH_URL: `${baseUrl}/auth/v1`,
    NEXT_PUBLIC_API_URL: `${baseUrl}/auth/v1`,
    NEXT_PUBLIC_NEST_API_URL: `${baseUrl}/usm/v1`,
    NEXT_PUBLIC_USM_UI_HOST_URL: `${baseUrl}/`,
    NEXT_PUBLIC_USM_BACKEND_API_URL: `${baseUrl}/usm/v1`,

    // NEXT_PUBLIC_CW_AUTH_URL: 'http://localhost:5000/auth/v1',
    // NEXT_PUBLIC_API_URL: 'http://localhost:5000/auth/v1',
    // NEXT_PUBLIC_NEST_API_URL: 'http://localhost:5050/usm/v1',
    // NEXT_PUBLIC_USM_UI_HOST_URL: 'http://localhost:3000',
    // NEXT_PUBLIC_USM_BACKEND_API_URL: 'http://localhost:5050/usm/v1',
  };
};
